import { Card, CardContent, CardSubTitle, CardTitle } from "@artists/uikit"
import { Skeleton } from "@mui/material"
import type { FC } from "react"

interface Props {
	len?: number
}
export const Loader: FC<Props> = ({ len = 8 }) => (
	<>
		{[...Array(len).keys()].map(i => (
			<Card key={i}>
				<Skeleton
					animation='wave'
					sx={{
						transform: "none",
						borderRadius: 0,
						paddingTop: "100%",
						"&:empty:before": { content: "''" },
					}}
				/>

				<CardContent>
					<CardTitle width='80%'>
						<Skeleton />
					</CardTitle>
					<CardSubTitle width='40%'>
						<Skeleton />
					</CardSubTitle>
				</CardContent>
			</Card>
		))}
	</>
)
